import { QueryCache, QueryClient } from "@tanstack/react-query";
import { Toast } from "./components/ui/toast";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (_error, query) => {
      if (query?.meta?.errorMessage) {
        Toast(query.meta.errorMessage);
      }
    },
  }),
});
